// forEach polyfill
if ( window.NodeList && !NodeList.prototype.forEach ) {
	NodeList.prototype.forEach = Array.prototype.forEach;
}

const elementsToShow = document.querySelectorAll( '.animate' );
const header = document.getElementById('header');
const headerStickyWrap = document.getElementById('header_sticky_wrap');
const debug = false;

const scrollProps = {
	'scrollStatus' 					: null,
	'scrollPercentage' 			: null,
	'scrollDirection'				: null,
	'windowY'								: null,
	'lastKnownY'						: null,
	'directionReversedAt' 	: null,
	'distanceSinceReverse' 	: null,
	'compressesAt'					: 400,
	'unsticksAt'						: 500,
	'directionThreshold'		: 80
};

let scroll = window.requestAnimationFrame; // || function( callback ){ window.setTimeout( callback, 1000/60 ); }


/**
 *
 *
 *
 */
const init = function() {

	if ( debug ) setupScrollDebugger();

	setupHeaderHoverTransition();
	loop();

};


/**
 * 
 * 
 * 
 */
const setupScrollDebugger = function() {

	const debugPane = document.createElement('div');
	debugPane.style.fontSize = '12px';
	debugPane.style.lineHeight = '1.4';
	debugPane.style.padding = '1rem';
	debugPane.style.right = '0';
	debugPane.style.top = '10rem';
	debugPane.style.backgroundColor = '#ffffff';
	debugPane.style.zIndex = '999';
	debugPane.style.position = 'fixed';
	debugPane.style.borderRadius = '0';
	debugPane.style.boxShadow = '0 0 2rem rgba(0,0,0,0.2)';
	debugPane.style.width = '12rem';
	document.body.appendChild(debugPane);

	const labels = [
		[ 'Scroll Status', 'scrollStatus' ],
		[ 'Scroll Direction', 'scrollDirection' ],
		[ 'Scroll Percentage', 'scrollPercentage' ],
		[ 'Window Y Position', 'windowY' ],
		[ 'Last Known Y', 'lastKnownY' ],
		[ 'Reversed at', 'directionReversedAt' ],
		[ 'Since reverse' , 'distanceSinceReverse'],
		[ 'Direction threshold', 'directionThreshold' ],
		[ 'Unsticks at', 'unsticksAt' ]
	];

	labels.forEach( (row) => {

		const label = row[0];
		const id = row[1];
		const nodeWrap = document.createElement('div');
		const nodeLabel = document.createElement('strong');
		const nodeValue = document.createElement('span');

		nodeLabel.innerHTML = label;
		nodeValue.setAttribute('id',id);
		nodeValue.innerHTML = '0';
		nodeWrap.style.display = "flex";
		nodeWrap.style.justifyContent = "space-between";
	
		nodeWrap.appendChild(nodeLabel);
		nodeWrap.appendChild(nodeValue);
		debugPane.appendChild(nodeWrap);

	} );

	updateDebugger();

};


/**
 * 
 * 
 * 
 */
const updateDebugger = function() {

	document.getElementById('scrollStatus').innerHTML = scrollProps.scrollStatus;
	document.getElementById('lastKnownY').innerHTML = scrollProps.lastKnownY;
	document.getElementById('windowY').innerHTML = Math.round(scrollProps.windowY * 100) / 100;
	document.getElementById('scrollPercentage').innerHTML = Math.round(scrollProps.scrollPercentage * 100) / 100;
	document.getElementById('scrollDirection').innerHTML = scrollProps.scrollDirection;
	document.getElementById('directionReversedAt').innerHTML = scrollProps.directionReversedAt;
	document.getElementById('distanceSinceReverse').innerHTML = scrollProps.distanceSinceReverse;
	document.getElementById('directionThreshold').innerHTML = scrollProps.directionThreshold;
	document.getElementById('unsticksAt').innerHTML = scrollProps.unsticksAt;

}


/**
 *
 *
 *
 */
const loop = function() {

	updateScrollProps();

	if ( debug ) updateDebugger();

	doHeaderScroll();
	compressHeader();
	watchForAnimationItems();
	topWatch();

	scroll( loop );

};


/**
 * 
 * 
 * 
 */
const watchForAnimationItems = function() {

	elementsToShow.forEach( ( element ) => {

		const baseClass = 'animated';

		// when element enters viewport
		if ( isElementInViewport( element ) ) {

			if ( element.classList.contains( baseClass ) ) {
				return;
			}

			element.classList.add( baseClass );

		}

	});

}


/**
 * 
 * 
 * 
 */
const updateScrollProps = function() {

	updateWindowY();
	updateScrollStatus();
	updateScrollPercentage();
	trackScrollReversal();

}


/**
 *
 *
 *
 */
const updateWindowY = function() {

	const supportPageOffset = window.pageXOffset !== undefined;
	const isCSS1Compat = ((document.compatMode || "") === "CSS1Compat");
	const windowY = supportPageOffset ? window.pageYOffset : isCSS1Compat ? document.documentElement.scrollTop : document.body.scrollTop;

	scrollProps.windowY = windowY;

}


/**
 * 
 * 
 * 
 */
const updateScrollStatus = function() {
	
	if ( scrollProps.windowY !== scrollProps.lastKnownY ) {

		if ( scrollProps.windowY > scrollProps.lastKnownY ) {

			if ( scrollProps.scrollDirection === 'up' ) scrollProps.directionReversedAt = scrollProps.windowY;

			scrollProps.scrollDirection = 'down';

		} else if ( scrollProps.windowY < scrollProps.lastKnownY ) {

			if ( scrollProps.scrollDirection === 'down' ) scrollProps.directionReversedAt = scrollProps.windowY;
			
			scrollProps.scrollDirection = 'up';

		}

		scrollProps.lastKnownY = scrollProps.windowY;
		scrollProps.scrollStatus = true;

	} else {

		scrollProps.scrollStatus = false;
	
	}

}


/**
 * 
 * 
 * 
 */
const trackScrollReversal = function() {

	if ( scrollProps.scrollDirection === 'down' ) {
		scrollProps.distanceSinceReverse = scrollProps.windowY - scrollProps.directionReversedAt;
	} else if ( scrollProps.scrollDirection === 'up' ) {
		scrollProps.distanceSinceReverse =  scrollProps.directionReversedAt - scrollProps.windowY;
	}

}


/**
 *
 *
 *
 */
const updateScrollPercentage = function() {

	const h = document.documentElement;
	const	b = document.body;
	const	st = 'scrollTop';
	const	sh = 'scrollHeight';
	const percentage = (h[st]||b[st]) / ((h[sh]||b[sh]) - h.clientHeight) * 100;

	scrollProps.scrollPercentage = percentage;

}


/**
 * 
 * 
 * 
 */
const setupHeaderHoverTransition = function() {
	
	if ( !headerStickyWrap.classList.contains('hide-on-scroll') ) return;

	header.addEventListener( 'mouseover', () => {
		headerStickyWrap.style.opacity = 1;
	} );

}


/**
 *
 *
 *
 */
const doHeaderScroll = function() {

	if ( !headerStickyWrap.classList.contains('hide-on-scroll') ) return;

	const distance = 200;

	if ( scrollProps.windowY <= distance ) {
		headerStickyWrap.style.opacity = 1;
		return;
	}

	if ( scrollProps.distanceSinceReverse >= distance && scrollProps.scrollStatus ) {

		if ( scrollProps.scrollDirection === 'down' ) {
			headerStickyWrap.style.opacity = 0;
		}
	
		if ( scrollProps.scrollDirection === 'up' ) {
			headerStickyWrap.style.opacity = 1;
		}

	}

};


/**
 *
 *
 *
 */
const compressHeader = function() {

	const reductionClass  = 'is-compressed';

	if ( scrollProps.windowY >= scrollProps.compressesAt && !header.classList.contains(reductionClass) ) {
		header.classList.add( reductionClass );
	} else if ( scrollProps.windowY < scrollProps.compressesAt && header.classList.contains(reductionClass) ) {
		header.classList.remove( reductionClass );
	}

}


/**
 * 
 * 
 * 
 */
const topWatch = function() {

	if ( !header ) return;

	const className = 'is-at-top';

	if ( scrollProps.windowY === 0 ) {
		header.classList.add( className );
	} else {
		header.classList.remove( className );
	}

}


/**
 *
 *
 *
 */
const isElementInViewport = ( el ) => {

	var rect = el.getBoundingClientRect();

	return (
		( rect.top <= 0 && rect.bottom >= 0 )
		||
		( rect.bottom >= ( window.innerHeight || document.documentElement.clientHeight ) && rect.top <= ( window.innerHeight || document.documentElement.clientHeight ) )
		||
		( rect.top >= 0 && rect.bottom <= ( window.innerHeight || document.documentElement.clientHeight ) )
	);

};


const api = {
	init: init
};

export default api;